import { render } from "./PernyataanView.vue?vue&type=template&id=54bb618a"
import script from "./PernyataanView.vue?vue&type=script&lang=js"
export * from "./PernyataanView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__